import useDateFormat from "hooks/useDateFormat";
import RCAUserWithAvatar from "../RCAUserWithAvatar";
import { useRCAHistoryMainStyles } from "../../RCA.styles";
import { IHistoryLogUser } from "./interfaces";

export const RCAHistoryLog = ({
    changeLog,
    changeType,
    changeDate,
    changeUser,
}: {
    changeLog: JSX.Element | undefined;
    changeType: JSX.Element | undefined;
    changeDate: Date;
    changeUser: IHistoryLogUser;
}) => {
    const classes = useRCAHistoryMainStyles();
    const { formatDate } = useDateFormat();

    return (
        <section>
            <div className={classes.avatarWrapper}>
                <RCAUserWithAvatar
                    imageUrl={changeUser?.media?.media_url}
                    name={`${changeUser?.first_name} ${changeUser?.last_name}`}
                    isObservation
                    hideText
                />
                <div className={classes.nameAndDateWrapper}>
                    <span className={classes.avatarName}>
                        <strong>{`${changeUser.first_name} ${changeUser.last_name}`}</strong> {changeType}
                    </span>
                    <span className={classes.avatarDate}>{formatDate(changeDate, true)}</span>
                </div>
            </div>
            <span className={classes.historyText}>{changeLog}</span>
        </section>
    );
};
